import "./instrument";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
import NewContainerFlow from './containers/NewContainerFlow';
import MyApp from './containers/MyApp';
import MyAppOverview from './containers/MyAppOverview';
import MyAppDeployments from './containers/MyAppDeployments';
import MyAppLogs from './containers/MyAppLogs';
import MyAppSource from './containers/MyAppSource';
import MyAppDatabase from './containers/MyAppDatabase';
import MyAppMetrics from './containers/MyAppMetrics';
import MyAppSettings from './containers/MyAppSettings';
import MyApps from './containers/MyApps';
import MyAgents from './containers/MyAgents';
import ConnectAgent from './containers/ConnectAgent';
import ClaimApps from './containers/ClaimApps';
import CreateAgent from './containers/CreateAgent';
import RequireAgentSubscription from './components/RequireAgentSubscription';
import StripeReturnPage from "./containers/StripeReturnPage";
import { Toaster } from 'react-hot-toast';
import './index.css';

async function bootstrap() {
  if (typeof globalThis.fetch !== 'function') {
    await import('cross-fetch/polyfill');
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          {/* The agents' pages: their own, outside the dashboard's shell. */}
          <Route path="connect" element={<ConnectAgent />} />
          <Route path="connect/device" element={<ConnectAgent device />} />
          <Route path="claim" element={<ClaimApps />} />
          <Route path="/" element={<App />}>
          <Route index element={<Navigate replace to="/apps" />} />
            <Route path="new-container" element={<NewContainerFlow />} />
            <Route path="return" element={<StripeReturnPage />} />
            <Route path="apps" element={<MyApps />} />
            <Route path="apps/:appId/" element={<MyApp />}>
              <Route index element={<MyAppOverview />} />
              <Route path="deployments" element={<MyAppDeployments />} />
              <Route path="source" element={<MyAppSource />} />
              <Route path="logs" element={<MyAppLogs />} />
              <Route path="database" element={<MyAppDatabase />} />
              <Route path="metrics" element={<MyAppMetrics />} />
              <Route path="settings" element={<MyAppSettings />} />
            </Route>
            <Route path="agents/new" element={<RequireAgentSubscription><CreateAgent /></RequireAgentSubscription>} />
            <Route path="agents" element={<RequireAgentSubscription><MyAgents /></RequireAgentSubscription>} />
            <Route path="agents/:agentId/" element={<RequireAgentSubscription><MyAgents /></RequireAgentSubscription>} />
          </Route>        
        </Routes>
      </BrowserRouter>
      <Toaster />
    </React.StrictMode>
  );
}

void bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
